import BinanceSvg from '@did/das-balance-assets/images/components/binance.svg'
import GasstationSvg from '@did/das-balance-assets/images/components/gasstation.svg'
import { Link } from '@did/das-balance-components'
import { Market } from '@did/constants'
import { LANGUAGE } from '@did/types/uikit'
import { useDasBalanceContext } from '@did/das-app-context'
import { collapseString, copyText } from '@did/tools'
import { Iconfont, QRCode } from '@did/uikit'
import React, { useMemo } from 'react'
import styles from './styles.module.scss'

export const ReceiveContent = () => {
  const { tt, lang, connectedAccount, toast } = useDasBalanceContext()
  const receiptFullAddress = useMemo(
    () => connectedAccount?.ckbAddress?.fullCkbAddress || '',
    [connectedAccount?.ckbAddress?.fullCkbAddress]
  )

  const onOpenMarket = (market: any) => {
    if (market.name === Market.gasstation) {
      window.location.href = market.link
    } else {
      window.open(market.link)
    }
  }

  const handleCopy = () => {
    copyText(receiptFullAddress).then(() => {
      toast('👌 ' + tt('Copied'))
    })
  }

  const marketList = useMemo(() => {
    const locationHref = `${window.location.origin}?from=gasstation`
    return [
      // {
      //   name: Market.gasstation,
      //   logo: <GasstationSvg />,
      //   link: `https://cryptogasstation.xyz/buy/NervosCKByte?ref=WDNBNM&address=${receiptFullAddress}&callbackUrl=${encodeURIComponent(
      //     locationHref
      //   )}`,
      // },
      {
        name: Market.binance,
        logo: <BinanceSvg />,
        link:
          lang?.value === LANGUAGE.zhCN
            ? 'https://www.binance.com/zh-CN/trade/CKB_USDT?ref=25821015'
            : 'https://www.binance.com/en/trade/CKB_USDT?ref=25821015'
      }
    ]
  }, [lang])

  const whyHerf = useMemo(() => {
    if (lang?.value === LANGUAGE.zhCN) {
      return 'https://talk.did.id/t/bestdas-com/115#h-350-ckb-7'
    }

    return 'https://talk.did.id/t/faq-bestdas-com/116#why-is-it-recommended-to-send-at-least-350-ckb-6'
  }, [lang])

  return (
    <div>
      <div className={styles.transitBalance__deposit__container}>
        <QRCode
          className={styles.transitBalance__deposit__qrcode}
          value={receiptFullAddress}
        />

        <span
          className={styles.transitBalance__receiptAddress}
          onClick={handleCopy}
        >
          {collapseString(receiptFullAddress, 6, 6)}
          <span
            className={styles.transitBalance__receiptAddress__dividingLine}
          />
          <Iconfont name="copy" color="#6F7684" size="15" />
        </span>
      </div>

      <div className={styles.buyCkbMarket}>
        {marketList.map((market) => (
          <div
            key={market.name}
            className={styles.buyCkbMarketItem}
            onClick={() => onOpenMarket(market)}
          >
            <span className={styles.buyCkbMarketItemTitle}>
              {tt('Buy CKB on')}
              {market.logo}
            </span>
            <Iconfont name="arrow-right" size="10" />
          </div>
        ))}
      </div>

      <div className={styles.transitBalance__deposit__alternateAddress}>
        <div className={styles.transitBalance__deposit__tips}>
          <span className={styles.transitBalance__deposit__tag}>*</span>
          <div>
            {tt('充值警告', {
              link: (
                <Link>
                  <a
                    className={styles.transitBalance__deposit__tips__link}
                    target="_blank"
                    href={whyHerf}
                  >
                    {tt('Why?')}
                  </a>
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
